// Validação de CPF/CNPJ (dígitos verificadores), seguindo o padrão oficial da Receita Federal.

export function validarCPF(cpf) {
  const digitos = (cpf || '').replace(/\D/g, '');
  if (digitos.length !== 11 || /^(\d)\1{10}$/.test(digitos)) return false;

  let soma = 0;
  for (let i = 0; i < 9; i++) soma += parseInt(digitos[i], 10) * (10 - i);
  let resto = soma % 11;
  const digito1 = resto < 2 ? 0 : 11 - resto;
  if (parseInt(digitos[9], 10) !== digito1) return false;

  soma = 0;
  for (let i = 0; i < 10; i++) soma += parseInt(digitos[i], 10) * (11 - i);
  resto = soma % 11;
  const digito2 = resto < 2 ? 0 : 11 - resto;
  return parseInt(digitos[10], 10) === digito2;
}

export function validarCNPJ(cnpj) {
  const digitos = (cnpj || '').replace(/\D/g, '');
  if (digitos.length !== 14 || /^(\d)\1{13}$/.test(digitos)) return false;

  const mult1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  let soma = 0;
  for (let i = 0; i < 12; i++) soma += parseInt(digitos[i], 10) * mult1[i];
  let resto = soma % 11;
  const digito1 = resto < 2 ? 0 : 11 - resto;
  if (parseInt(digitos[12], 10) !== digito1) return false;

  const mult2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  soma = 0;
  for (let i = 0; i < 13; i++) soma += parseInt(digitos[i], 10) * mult2[i];
  resto = soma % 11;
  const digito2 = resto < 2 ? 0 : 11 - resto;
  return parseInt(digitos[13], 10) === digito2;
}

// tipo: 'CPF' ou 'CNPJ'. Campo vazio é considerado válido (obrigatoriedade é responsabilidade de quem chama).
export function validarDocumento(valor, tipo) {
  const digitos = (valor || '').replace(/\D/g, '');
  if (!digitos) return true;
  return tipo === 'CNPJ' ? validarCNPJ(digitos) : validarCPF(digitos);
}

// Retorna a mensagem de erro apropriada para o documento informado, ou '' se estiver válido/vazio.
export function mensagemErroDocumento(valor, tipo) {
  const digitos = (valor || '').replace(/\D/g, '');
  if (!digitos) return '';
  const tamanhoEsperado = tipo === 'CNPJ' ? 14 : 11;
  if (digitos.length !== tamanhoEsperado) {
    return `${tipo} deve ter ${tamanhoEsperado} dígitos`;
  }
  if (!validarDocumento(digitos, tipo)) {
    return `${tipo} inválido. Verifique os números digitados.`;
  }
  return '';
}
